import type { ApolloError } from "@apollo/client";

export function isCrossOrgAccessError(error: ApolloError | undefined): boolean {
  return (
    error?.message?.includes(
      "does not have access to get user-public-information",
    ) ?? false
  );
}
